import { render, staticRenderFns } from "./WizardPage.vue?vue&type=template&id=401e19a1&scoped=true&"
import script from "./WizardPage.vue?vue&type=script&lang=js&"
export * from "./WizardPage.vue?vue&type=script&lang=js&"
import style0 from "./WizardPage.vue?vue&type=style&index=0&id=401e19a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e19a1",
  null
  
)

export default component.exports